import { useState, useCallback } from "react"
import PropTypes from "prop-types"
import { replace } from "lodash"
import { Avatar, ListItemAvatar, ListItem, ListItemText, Button } from "@mui/material"
import { CloudDownload } from "@mui/icons-material"
import classNames from "classnames"
import { fileDownload } from "helpers/csv"
import { appendTimestamp } from "modules/server-notifications/helpers"

export default function ServerLink({ filePath, createdAt }) {
  const [error, setError] = useState(false)

  const securitySearchDownload = useCallback(async () => {
    if (error) { return }
    const response = await fetch("/securitySearchDownload", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        filePath,
      }),
    })

    if (!response.ok) {
      setError(true)
      return
    }
    const data = await response.blob()
    const name = replace(filePath.substr(filePath.lastIndexOf("/") + 1), ".csv", ".xlsx")
    fileDownload(data, name)
  }, [error, filePath])

  return <ListItem
    className="success"
    secondaryAction={<Button className={classNames({ error })} color="primary" onClick={() => securitySearchDownload()}>
      {!error ? "Download" : "Error"}
    </Button>}
  >
    <ListItemAvatar>
      <Avatar>
        <CloudDownload />
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary="Your file is ready" secondary={appendTimestamp("Security Search Results", createdAt)} />
  </ListItem>
}

ServerLink.propTypes = {
  filePath: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
}
